// extracted by mini-css-extract-plugin
module.exports = {"bubble":"ReferralEvent_bubble__2ep0U","user":"ReferralEvent_user__5S1Im","timestamp":"ReferralEvent_timestamp__2Xyth"};